var styles = {
  "TableCellContentContainer": "Polaris-IndexTable-Checkbox__TableCellContentContainer",
  "Wrapper": "Polaris-IndexTable-Checkbox__Wrapper",
  "expanded": "Polaris-IndexTable-Checkbox--expanded",
  "condensed": "Polaris-IndexTable-Checkbox--condensed"
};

export { styles as default };
